import componentIsStart from './current-page-is-start';
export default (state, action) => {
    if (componentIsStart(state)) {
        const startPage = state;
        switch (action.type) {
            default:
                return startPage;
        }
    }
    return state;
};
